// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"678":"component---src-pages-index-js","883":"component---src-pages-404-js"}[chunkId] + "-" + {"678":"ed6633ac9aa4e36ca31c","883":"e25466a758a29e2ac92c"}[chunkId] + ".js";
};